const breakpoints = ['320px', '375px', '768px', '1028px', '1750px'];

[breakpoints.sm, breakpoints.md, breakpoints.lg, breakpoints.xl, breakpoints.xxl] = breakpoints;

const theme = {
	space: [
		'0',
		'2px',
		'4px',
		'6px',
		'8px',
		'12px',
		'16px',
		'20px',
		'24px',
		'28px',
		'32px',
		'36px',
		'40px',
		'44px',
		'48px',
		'52px',
		'56px',
		'60px',
		'112px'
	],
	sizes: [
		'0',
		'2px',
		'4px',
		'6px',
		'8px',
		'12px',
		'16px',
		'20px',
		'24px',
		'28px',
		'32px',
		'36px',
		'40px',
		'44px',
		'48px',
		'52px',
		'56px',
		'60px',
		'112px'
	],
	radii: ['0', '2px', '18px', '9999px'],

	breakpoints
};

export default theme;
